
import React from 'react';
import MessageSection from './MessageSection';
import ProcessSection from './ProcessSection';
import BenefitsSection from './BenefitsSection';
import TestSection from './TestSection';
import AuctionSection from './AuctionSection';
import CoverageSection from './CoverageSection';
import ContactSection from './ContactSection';

interface SellCarContentProps {
  onValuationClick: () => void;
}

const SellCarContent = ({ onValuationClick }: SellCarContentProps) => {
  return (
    <>
      <MessageSection />
      <ProcessSection onValuationClick={onValuationClick}/>
      <BenefitsSection />
      <TestSection />
      <AuctionSection />
      <CoverageSection />
      <ContactSection onValuationClick={onValuationClick} />
    </>
  );
};

export default SellCarContent;
